<div style="text-align: center; font-weight: bold; margin-top: 20px;">
  Sorry: This page does not exist or you are not authorized to see it<br />
  Use the drawer to navigate or <a routerLink="/kyc/list">click here to go Home</a>.
</div>
